<template>
  <!-- /*
   * 自定义svg图标组件，默认svg文件需要放在/src/assets/icons/文件夹下。
   * 使用时可以用css的color属性和width和height属性,自定义大小和颜色
   * 如果svg图片要根据当前color颜色渲染需要：
   * 1.在svg标签中加上 fill="currentColor" stroke="currentColor"
   * 2.在path标签中去掉 fill属性，或者改为 fill="currentColor" stroke="currentColor"
  
   * 3.注意：vite-plugin-svg-icons无法通过use里的fill属性来改变颜色，
   * 当确实需要设置时，应将svg文件中的fill属性删除，可能svg和path上都会有个fill
   * */ -->
  <i :class="[`${namespace}-icon`, 'svg-icon-v', { spin }]">
    <svg aria-hidden="true">
      <use :xlink:href="symbolId" :fill="color" />
    </svg>
  </i>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useNamespace } from 'element-plus';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    color: String,
    spin: Boolean,
  },
  setup(props) {
    const symbolId = computed(() => `#icon-${props.name}`);

    const ns = useNamespace('button'); // 获取 button 的命名空间
    const namespace = ns.namespace;

    return { symbolId, namespace };
  },
});
</script>

<style lang="less">
.spin {
  animation: van-rotate 1s linear infinite;
}

.svg-icon-v {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
  color: currentColor;
  line-height: 0;
}

.svg-icon-v svg {
  display: inline-block;
  height: 100%;
  width: 100%;

  path {
    fill: inherit !important;
  }
}
</style>
